import { z } from 'zod';
import type { InventoryReportType } from 'contracts/inventory-2/uploads';
import {
  MAX_INVENTORY_UPLOAD_SIZE,
  XLSX_ONLY_UPLOAD_TYPES,
} from 'constants/inventory-2/uploads';

const fileExtension = (file: File) => {
  const parts = file.name.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
};

export const formSchema = z.object({
  uploadType: z.custom<InventoryReportType>()
    .refine((value) => !!value, 'Selecione o tipo de arquivo'),
  file: z.instanceof(FileList),
}).superRefine((formData, ctx) => {
  const { file: fileList, uploadType } = formData;
  const xlsxOnly = XLSX_ONLY_UPLOAD_TYPES.includes(uploadType);
  const expectedMessage = xlsxOnly
    ? 'Selecione um arquivo no formato .xlsx'
    : 'Selecione um arquivo no formato .csv ou .xlsx';

  if (!(fileList instanceof FileList) || fileList.length === 0) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: expectedMessage,
      path: ['file'],
    });
  }

  const file = fileList[0];
  const extension = fileExtension(file);
  const accepted = xlsxOnly ? ['xlsx'] : ['csv', 'xlsx'];

  if (!accepted.includes(extension)) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: expectedMessage,
      path: ['file'],
    });
  }

  if (file.size > MAX_INVENTORY_UPLOAD_SIZE) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Arquivo não pode exceder 50 MB',
      path: ['file'],
    });
  }
});

export type FormSchema = z.infer<typeof formSchema>;
export type UploadType = FormSchema['uploadType'];
